import { GetUnnamedJourneyResponse, JourneyDetail } from '@fullstory/proto/fs/services/dx-objects';
import {
  QueryCacheOptions,
  ComputeJourneyMapRequest,
  SampleOptions,
} from '@fullstory/proto/fs/services/alexa';
import { EventIdentValues, JourneyMap } from '@fullstory/proto/fs/api/segment';
import { timestamp } from '@fullstory/proto/google/protobuf';
import { JourneyMapSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';

export type JourneysById = { [id: string]: JourneyDetail };
export type JourneysState = JourneysById;
export type UnnamedJourneyState = GetUnnamedJourneyResponse;

export enum JourneysRequestTypes {
  GetAllJourneysRequest = 'Journeys.GetAll.Request',
  GetAllJourneysSuccess = 'Journeys.GetAll.Success',
  GetAllJourneysFailure = 'Journeys.GetAll.Failure',
  SetJourneyRequest = 'Journeys.Set.Request',
  SetJourneySuccess = 'Journeys.Set.Success',
  SetJourneyFailure = 'Journeys.Set.Failure',
  ArchiveJourneyRequest = 'Journeys.Archive.Request',
  ArchiveJourneySuccess = 'Journeys.Archive.Success',
  ArchiveJourneyFailure = 'Journeys.Archive.Failure',
  StarJourneyRequest = 'Journeys.Star.Request',
  StarJourneySuccess = 'Journeys.Star.Success',
  StarJourneyFailure = 'Journeys.Star.Failure',
  MarkJourneyViewedRequest = 'Journeys.MarkViewed.Request',
  MarkJourneyViewedSuccess = 'Journeys.MarkViewed.Success',
  MarkJourneyViewedFailure = 'Journeys.MarkViewed.Failure',
  GetJourneyAccessRequest = 'Journeys.GetAccess.Request',
  GetJourneyAccessSuccess = 'Journeys.GetAccess.Success',
  GetJourneyAccessFailure = 'Journeys.GetAccess.Failure',
  ComputeJourneyRequest = 'Journeys.Compute.Request',
  ComputeJourneySuccess = 'Journeys.Compute.Success',
  ComputeJourneyFailure = 'Journeys.Compute.Failure',
  JourneysAppCacheIsLoading = 'Journeys.APP_CACHE_IS_LOADING',
  JourneysAppCacheLoadFailed = 'Journeys.APP_CACHE_LOAD_FAILED',
  JourneysAppCacheRefetching = 'Journeys.APP_CACHE_IS_REFETCHING',
  JourneysAppCacheHasData = 'Journeys.APP_CACHE_HAS_DATA',
  JourneysAppCacheFresh = 'Journeys.APP_CACHE_FRESH',
  JourneysAppCacheSwap = 'Journeys.APP_CACHE_SWAP',
  JourneysAppCacheClear = 'Journeys.APP_CACHE_CLEAR',
  CreateUnnamedJourneyRequest = 'Journeys.CreateUnnamedJourney.Request',
  CreateUnnamedJourneySuccess = 'Journeys.CreateUnnamedJourney.Success',
  CreateUnnamedJourneyFailure = 'Journeys.CreateUnnamedJourney.Failure',
  GetUnnamedJourneyRequest = 'Journeys.GetUnnamedJourney.Request',
  GetUnnamedJourneySuccess = 'Journeys.GetUnnamedJourney.Success',
  GetUnnamedJourneyFailure = 'Journeys.GetUnnamedJourney.Failure',
}

export interface JourneyComputationRequestBody
  extends Omit<ComputeJourneyMapRequest, 'now' | 'timezone' | 'cacheOptions' | 'sampleOptions'> {
  cacheOptions?: QueryCacheOptions;
  sampleOptions?: SampleOptions;
}

export interface FlatJourney {
  id: string;
  name: string;
  description: string;
  journeyMap: JourneyMap;
  journeyMapSettings: JourneyMapSettings;
  archived: boolean;
  starred: boolean;
  created: timestamp | null;
  createdBy: string;
  lastUpdated: timestamp | null;
  lastUpdatedBy: string;
  lastViewed: timestamp | null;
  visibility: Visibility;
}

export type JourneyMapFormType = Pick<
  FlatJourney,
  'id' | 'name' | 'description' | 'archived' | 'journeyMap' | 'journeyMapSettings' | 'visibility'
>;

export type JourneyMapSessionFilter = { values: EventIdentValues | null; hash: string };

export type JourneyMapConfigSettings = {
  filters: { [depth: number]: JourneyMapSessionFilter } | null;
  journeyMapConfig: JourneyMapFormType | null;
  limit: number;
};
